import {atom} from "recoil";
import {FormSearchGreenDiscountModel, GreenDiscountCreation} from "../api/types/greenDiscount";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";
import {SelectElementModelBE} from "../api/types/generic";

export const initialGreenDiscountFilters: FormSearchGreenDiscountModel = {
    name: "",
    commercialSegmentId: null,
    commercialCategoryId: null,
    reservationFrom: "",
    reservationTo: "",
    pickupFrom: "",
    pickupTo: "",
    showOnlyActive: false,
    dealers: [],
    legalEntities: []
};

export const greenDiscountFiltersAtom = atom<FormSearchGreenDiscountModel>({
    key: "greenDiscountFiltersAtom",
    default: initialGreenDiscountFilters
});

export const initialGreenDiscountCreation: GreenDiscountCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false]
};
export const greenDiscountCreationAtom = atom({
    key: "greenDiscountCreationAtom",
    default: initialGreenDiscountCreation
});

export const acrissListAtom = atom<SelectElementModelBE[]>({
    key: "acrissList",
    default: []
})